export default __webpack_public_path__ + "static/media/BG_Landing.520043a1.jpg";